'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Throttle = exports.Debounce = undefined;

var _Debounce = require('./components/Debounce');

var _Debounce2 = _interopRequireDefault(_Debounce);

var _Throttle = require('./components/Throttle');

var _Throttle2 = _interopRequireDefault(_Throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Debounce = _Debounce2.default;
exports.Throttle = _Throttle2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-throttle/lib/index.js
// module id = 2889
// module chunks = 0